<script setup>
import CustomToggle from '@/components/global-themed/CustomToggle.vue';
import {useFeatureFlags} from '@/composables/admin/useFeatureFlags';

const { user, features, toggleFeature, isToggling } = useFeatureFlags();
</script>

<template>
  <div>
    <div class="tw-mb-6">
      <h2 class="tw-text-lg tw-font-semibold tw-text-font-primary">
        {{ user.name }}
      </h2>
      <p class="tw-text-sm tw-text-gray-500">
        {{ user.email }}
      </p>
    </div>

    <table class="tw-w-full tw-text-sm">
      <thead>
        <tr class="tw-border-b tw-border-gray-200">
          <th class="tw-text-left tw-pb-2 tw-font-medium tw-text-gray-600">
            Feature
          </th>
          <th class="tw-text-right tw-pb-2 tw-font-medium tw-text-gray-600">
            State
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="flag in features"
          :key="flag.feature"
          class="tw-border-b tw-border-gray-100 last:tw-border-0"
        >
          <td class="tw-py-3 tw-text-font-primary">
            {{ flag.label }}
          </td>
          <td class="tw-py-3">
            <div
              class="tw-flex tw-items-center tw-justify-end tw-gap-2"
              :class="{ 'tw-opacity-50 tw-pointer-events-none': isToggling }"
            >
              <span>{{ flag.enabled ? 'Enabled' : 'Disabled' }}</span>
              <CustomToggle
                :model-value="flag.enabled"
                @update:model-value="(val) => toggleFeature(flag.feature, val)"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
